import React from "react"
import illovo from "./../content/assets/utlo-logo.svg"


export default () => {
  return (
    <>
     
      <div className="w-100 bg-orange-700 min-vh-40 pb5 mt2">
        <div className="mw-1400 center w-100 ph4">
          <div className="flex flex-column ">
           

            <div className="f6 white-100 ls1 lh-copy">
              <div className="bg-white-100 mw-8 mb2">
                <img className="h7" src={illovo} alt="..." />
              </div>
              <div className="fw5"> Contact UTLO: </div>
              <div className="fw3"> 2nd Floor, Francis Stock Building </div>
              <div className="fw3"> Howard College Campus </div>
              <div className="fw3">University of KwaZulu-Natal, Durban, 4041, South Africa. </div>
              <div className="fw3"> Tel: +27 (0)31 260-3002 </div>
              <div className="fw3"> Email:  <a className="white-100" href="mailto:utlo@ukzn.ac.za">utlo@ukzn.ac.za</a>  </div>
              <div className="fw3"> Website:  <a className="white-100" href="http://www.utlo.ukzn.ac.za/">http://www.utlo.ukzn.ac.za/</a>  </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}